var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('h2',[_vm._v("Articles")]),_c('alert',{ref:"alert"}),_c('article-form',{attrs:{"article-list":_vm.articles}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }